import { observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button, Form, Grid, Header, Icon, Table, Segment, Label } from "semantic-ui-react";
import {
  AlertMessage,
  AttachedFile,
  DateInput,
  SubSectionContainer,
} from "../../../components/common";
import { CurrencyInput } from "../../../components/common/input";
import {
  NoPermissionMessage,
  PermissionControl
} from "../../../components/permission";
import { hasPermission } from "../../../utils/render-by-permission";
import { IAuthModel } from "../../auth/AuthModel";
import { IDebtCollectionModel } from "../DebtCollectionModel";

interface IDebtCollectionTerminatedForm extends WithTranslation {
  debtCollection: IDebtCollectionModel;
  editMode?: boolean;
  authStore?: IAuthModel;
}

@observer
class DebtCollectionTerminatedForm extends React.Component<IDebtCollectionTerminatedForm> {
  state = {
    terminatedContact: false
  }
  public render() {
    const { t, debtCollection } = this.props;
    return (
      <React.Fragment>
        <Grid columns={"2"}>
          <Grid.Column>
            {t("บอกเลิกสัญญากรุณากดปุ่ม บอกเลิกสัญญา ")}
            <PermissionControl
              codes={["DEBTCOLLECTION.LEGAL.PRINT.CANCELLETTER"]}
            >
              <Button color={"orange"} onClick={() => { this.setState({ terminatedContact: true }) }}>
                <Icon name="print" />
                {t(
                  "บอกเลิกสัญญา"
                )}
              </Button>
              <Segment>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <AttachedFile
                        files={debtCollection.terminatedFileList}
                        mode="edit"
                        multiple={true}
                        addFiles={debtCollection.addTerminatedFiles}
                        removeFile={(index?: number) => debtCollection.removeTerminatedFile(index!)}
                        fieldName="debtCollection.terminatedAttachedFiles"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column textAlign={"right"}>
                      <Button
                        content={t("module.debtCollection.debtCollectionSueForm.submit")}
                        color={"blue"}
                        onClick={debtCollection.saveTerminatedFiles}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>

            </PermissionControl>
          </Grid.Column>
          {this.state.terminatedContact ? (
            <Grid.Column textAlign={"right"}>
              <PermissionControl
                codes={["DEBTCOLLECTION.LEGAL.PRINT.CANCELLETTER"]}
              >
                <Label size="large" basic color='blue'>{t(
                  "module.debtCollection.debtCollectionSueForm.printDenounceTheBorrower"
                )}</Label>
                <br></br>
                <Button color={"orange"} onClick={debtCollection.printCancelBorrower}>
                  <Icon name="print" />
                  {t(
                    "PDF"
                  )}
                </Button>
                <Button color={"purple"} onClick={debtCollection.printCancelBorrowerWord}>
                  <Icon name="print" />
                  {t(
                    "WORD"
                  )}
                </Button>
              </PermissionControl>
              <br />
              <br />
              <PermissionControl
                codes={["DEBTCOLLECTION.LEGAL.PRINT.GUARANTORLETTER"]}
              >
                <Label size="large" basic color='blue'>{t(
                  "module.debtCollection.debtCollectionSueForm.printDenounceTheGuarantor"
                )}</Label>

                <br></br>
                <Button color={"orange"} onClick={debtCollection.printCancelGurantor}>
                  <Icon name="print" />
                  {t(
                    "PDF"
                  )}
                </Button>
                <Button color={"purple"} onClick={debtCollection.printCancelGurantorWord}>
                  <Icon name="print" />
                  {t(
                    "WORD"
                  )}
                </Button>
              </PermissionControl>

            </Grid.Column>
          ) : ("")}
        </Grid>
      </React.Fragment>
    );
  }

}

export default withTranslation()(DebtCollectionTerminatedForm);
